import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-503Error',
  templateUrl: './503error.component.html',
  styleUrls: ['./503error.component.css']
})
export class Error503Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}